// This file should only contain action type constants.

export const SET_MEDIA = 'SET_MEDIA';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
